import { IGambleConfiguration } from '@GFTypes/GameStoreTypes/GambleConfiguration';

export const GAMBLE_CONFIGURATION_DEFAULTS: IGambleConfiguration = {
    gambleFont: '',
    gambleFontSize: ''
};
